import { useLang } from "../contexts/LanguageContext";

function Cell({ label, value }) {
  if (!value) return null;
  return (
    <div className="border border-zinc-800 px-4 py-3">
      <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">
        {label}
      </div>
      <div className="font-mono text-sm text-zinc-200 mt-1 break-words">{value}</div>
    </div>
  );
}

export default function ExifPlaque({ exif }) {
  const { t } = useLang();
  const has =
    exif &&
    (exif.camera_model ||
      exif.camera_make ||
      exif.iso ||
      exif.aperture ||
      exif.shutter ||
      exif.focal_length ||
      exif.lens ||
      exif.width);

  if (!has) {
    return (
      <div
        className="border border-zinc-800 px-4 py-6 text-zinc-500 font-mono text-xs uppercase tracking-[0.25em]"
        data-testid="exif-empty"
      >
        {t("no_exif")}
      </div>
    );
  }

  const camera = [exif.camera_make, exif.camera_model].filter(Boolean).join(" ");
  const resolution =
    exif.width && exif.height ? `${exif.width} × ${exif.height}` : "";

  return (
    <div className="grid grid-cols-2 gap-[-1px]" data-testid="exif-plaque">
      <Cell label={t("camera")} value={camera} />
      <Cell label={t("lens")} value={exif.lens} />
      <Cell label={t("iso")} value={exif.iso} />
      <Cell label={t("aperture")} value={exif.aperture} />
      <Cell label={t("shutter")} value={exif.shutter} />
      <Cell label={t("focal_length")} value={exif.focal_length} />
      <Cell label={t("resolution")} value={resolution} />
      <Cell label={t("date_taken")} value={exif.date_taken} />
    </div>
  );
}
